<template>
  <div class="services-container">
    <div class="services-title">
      <h1>NOS SERVICES</h1>
      <div class="breadcrumb">
        <a href="/">Accueil</a> > <a href="/services">Services</a>
      </div>
    </div>
    <div class="supracare-description">
      <h2>Service de conseil</h2>
      <p>
        Supracare offre des services de conseil pour aider les laboratoires et les établissements de santé à choisir les meilleures solutions pour leurs besoins.
      </p>

      <h2>Maintenance des équipements</h2>
      <p>
        Nos équipes techniques sont à votre disposition pour assurer l'entretien régulier et la maintenance de vos équipements de laboratoire.
      </p>

      <h2>Formation</h2>
      <p>
        Nous offrons des formations pour garantir l'utilisation optimale des produits que nous fournissons.
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ServicesPage',
};
</script>

<style scoped>
/* Conteneur principal */
.services-container {
  padding: 0px 0px;
  background-color: #f9f9f9;
  text-align: justify;
  z-index: 1;
  overflow: hidden;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}

/* Ajout d'une superposition transparente */
.services-container::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.5);
  z-index: -1;
}

/* Titre avec image de fond */
.services-title {
  position: relative;
  background-image: url('C:/Users/PC MAROC/supracare_web/src/assets/img6.jpg');
  background-size: cover;
  background-position: center;
  color: rgb(29, 22, 77);
  padding: 95px 300px;
  font-size: 14px;
  margin: 0 auto;
  text-align: center;
  border-radius: 2px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  max-width: 1000px;
  z-index: 1;
}

/* Breadcrumb */
.breadcrumb {
  font-size: clamp(0.8rem, 2vw, 1rem); /* Flexibilité pour taille d'écriture */
  color: #555;
  margin-top: 20px;
}

.breadcrumb a {
  color: #0c0c0c;
  text-decoration: none;
  font-weight: bold;
}

.breadcrumb a:hover {
  text-decoration: underline;
}

/* Description avec padding et box-shadow */
.supracare-description {
  padding: clamp(20px, 5vw, 100px); /* Flexibilité pour ajuster padding */
  box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.1);
  border-radius: 5px;
  background-color: #fff;
  margin: 20px auto;
  max-width: 1000px;
  font-family: 'Open Sans', sans-serif;
}

/* Titres dans la description */
.supracare-description h2 {
  color: #4c4a4d;
  font-size: clamp(1.5rem, 2.5vw, 2rem); /* Flexibilité pour les titres */
  margin-bottom: 15px;
  font-family: 'Merriweather', serif;
}

/* Paragraphes */
.supracare-description p {
  font-size: clamp(1rem, 2vw, 1.2rem); /* Taille fluide des textes */
  line-height: 1.75;
  color: #333;
  margin-bottom: 20px;
}



/* Responsive pour les petits écrans */
@media (max-width: 768px) {
  .services-title {
    font-size: clamp(1.5rem, 5vw, 1rem);
    padding: 100px 0px;
  }

  .breadcrumb {
    font-size: 0.9rem;
  }

  .supracare-description {
    padding: 20px;
  }

  .supracare-description h2 {
    font-size: 1.5rem;
  }

  .supracare-description p {
    font-size: 1rem;
  }
}
</style>

